export default "__VITE_ASSET__CPb68u3L__"